import { COLORS } from 'helpers/globals'

export default {
  "input[type='email'], input[type='number'], input[type='password'], input[type='search'], input[type='tel'], input[type='text'], input[type='url'], textarea, select": {
    appearance: 'none',
    backgroundColor: 'transparent',
    border: `.1rem solid ${COLORS.quaternary}`,
    boxShadow: 'none',
    height: '3rem',
    padding: '.6rem',
    width: '100%',
    borderRadius: '0rem',
    '-webkit-appearance': 'none',
    '&:focus': {
      border: '.1rem solid $color-primary',
      outline: 0
    }
  },
  select: {
    padding: '.6rem 3rem .6rem .6rem'
  },
  textarea: {
    minHeight: '6.5rem',
    paddingBottom: '.6rem',
    paddingTop: '.6rem'
  },
  'label, legend': {
    display: 'block',
    fontSize: '1.6rem',
    fontWeight: 700,
    marginBottom: '.5rem'
  },
  fieldset: {
    borderWidth: 0,
    padding: 0
  },
  "input[type='checkbox'], input[type='radio']": {
    display: 'inline'
  }
}



// WEBPACK FOOTER //
// ./src/assets/globalStyles/form.js